$(document).ready(function () {
  const $form = $('.product-form');
  const $submitButton = $form.find('.product-form__submit');
  const $submitButtonText = $submitButton.find('.button-text');

  $form.on('submit', function (event) {
    event.preventDefault(); // Prevent the default form submission

    // Disable the submit button immediately after submission
    $submitButton.prop('disabled', true);
    $submitButtonText.text('Adding...'); // Change button text

    const formData = $form.serializeArray();
    const productId = formData.find(item => item.name === 'id').value;
    const sellingPlanId = formData.find(item => item.name === 'selling_plan').value;

    // Check if Rebuy is ready to handle the request
    if (window.Rebuy) {
      // If Rebuy is initialized, use their method
      window.Rebuy.addToCart(productId, 1, sellingPlanId).then(() => {
        $submitButtonText.text('You are a member!'); // Change button text after successful addition
      }).catch(error => {
        console.error('Error adding to cart:', error);
        // Reset the button state if needed
        $submitButton.prop('disabled', false);
        $submitButtonText.text('Add to Bag'); // Reset button text
      });
    } else {
      // Fallback to default AJAX request if Rebuy is not ready
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          id: productId,
          selling_plan: sellingPlanId,
          quantity: 1,
          properties: {
            _inveterate_subscription: true
          }
        }),
        success: function (data) {
          console.log('Item added to cart:', data);
          $submitButtonText.text('You are a member!'); // Change button text after successful addition
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('There was a problem with the fetch operation:', textStatus, errorThrown);
          // Reset the button state if needed
          $submitButton.prop('disabled', false);
          $submitButtonText.text('Add to Bag'); // Reset button text
        }
      });
    }
  });
});